import React from 'react';
import './RepairInfoModal.css';
import closeIcon from '../assets/icons/closeIcons.webp';
import toolIcon from '../assets/icons/tool.webp';
import hammerIcon from '../assets/icons/hammer_icon.webp'; // örnek, sen kendi ikonunu koy
import NFT_TEMPLATES from '../config/nftTemplates';
import SEASONS from '../config/seasons';

export default function RepairInfoModal({ open, onClose, selectedNFT, seasonId }) {
  if (!open || !selectedNFT || !seasonId) return null;

  const season = SEASONS.find(s => s.id === seasonId);
  if (!season) return null;

  const maxDur = selectedNFT.durability?.second || 100;
  const currentDur = selectedNFT.durability?.first || 0;
  const missingDur = maxDur - currentDur;

  const template = NFT_TEMPLATES.find(t => t.template_id === selectedNFT.template_id);
  const toolPerDur = season.durability_cost / 100;
  const totalTool = (missingDur * parseFloat(toolPerDur)).toFixed(4);

  return (
    <div className="modall-overlay" onClick={onClose}>
      <div className="modall-panel repair-modall" onClick={e => e.stopPropagation()}>        
        <img src={hammerIcon} className="modall-icon" alt="repair" />

        <div className="repair-rate">
          <div className="rate-row">
            <img src={hammerIcon} className="rate-icon" alt="durability" />
            <span className="rate-text">1 Durability = {toolPerDur} TOOL</span>
            <img src={toolIcon} className="rate-icon" alt="tool" />
          </div>
          <div className="rate-row">
            <img src={toolIcon} className="rate-icon" alt="tool" />
            <span className="rate-text">{totalTool} TOOL</span>
          </div>
          <div className="rate-subtext">required to fully repair this NFT.</div>
        </div>

        <button className="menu-energy-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
